import {
  AloftPrice,
  expected,
  isDefined,
  orUndefined,
  schAlertType,
  schAloftPrice,
  schPairedCostRouteItem,
} from '@aloft/toolkit-shared';

import { SubjectPropertyDataState } from '../../../../redux/types.ts';
import { AlertDefinition } from '../../types.ts';

export const bracketedMarketValue: AlertDefinition = ({
  compAdjustments,
  compSequence,
  improvementCosts,
  order,
  propertyDataEntities,
}) => {
  const subjectImprovementCost = improvementCosts.subject;
  const subjectSiteValue = orUndefined(schAloftPrice.parse)(
    (propertyDataEntities.subject as SubjectPropertyDataState | undefined)?.subjectData.editableData
      .opinionOfSiteValue,
  );

  if (!subjectImprovementCost || !subjectSiteValue) return undefined;

  const subjectMarketValue = subjectImprovementCost.add(subjectSiteValue);
  const compAdjustedSalePrices = compSequence
    .map((id) => compAdjustments[id]?.adjustedSalePrice.adjustment)
    .filter(isDefined);

  if (!subjectMarketValue || compAdjustedSalePrices.length < 2) return undefined;

  const minAdjustedSalePrice = expected(AloftPrice.min(compAdjustedSalePrices));
  const maxAdjustedSalePrice = expected(AloftPrice.max(compAdjustedSalePrices));

  if (subjectMarketValue.ge(minAdjustedSalePrice) && subjectMarketValue.le(maxAdjustedSalePrice)) {
    return undefined;
  }

  return {
    type: schAlertType.enum.bracketedMarketValue,
    status: 'active',
    message: `Market Value (${subjectMarketValue.toString()}) is not bracketed by the adjusted sales price range of comparables (${minAdjustedSalePrice.toString()} - ${maxAdjustedSalePrice.toString()})`,
    propertyID: 'subject',
    fixingInfo: {
      tips: 'Tips: Bracketing is a key appraisal practice used to demonstrate support for the final value conclusion and ensure consistency with the comparable sales analysis. Revise the Opinion of Market Value so that it is bracketed, or provide clear commentary supporting why the value falls outside of that range',
      pairedCostRouteItem:
        schPairedCostRouteItem.enum[order.isInspectifyOrder ? 'adjustments-grid' : 'adjustments'],
    },
  };
};
